'use es6';

import { createSelector } from 'reselect';
export const getPage = (state, props) => state.pages.pages[props.pageLinkId];
const getPagesCache = state => state.pages.cache.pages;
const getPagesOrder = state => state.pages.cache.order;
export const getPagesById = state => state.pages.pages;
export const getPagesFetchRequestStatus = state => state.pages.pagesRequestStatus;
export const getCachedPage = (state, props) => state.pages.cache.pages[props.pageLinkId];
export const getPagesOptions = createSelector([getPagesCache, getPagesOrder], (cache, order) => {
  return order.map(id => {
    const page = cache[id];
    return {
      text: page.name,
      value: page.id,
      help: page.absoluteUrl
    };
  });
});